import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import styles from "./count.module.scss";

export const ElearningHomeCount = () => {
  const [focus, setFocus] = React.useState(false);
  return (
    <section>
      <div className="container">
        <div className={styles.wrapper}>
          <h3 className={styles.heading}>
            <span className={"color-orange"}>Impact</span> That Counts
          </h3>
          <div className={styles.count_wrapper}>
            <ul>
              <li>
                <div className={styles.count_number}>
                  <span>
                    <CountUp
                      start={focus ? 0 : null}
                      end={5000}
                      duration={2}
                      redraw={true}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                          <VisibilitySensor
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setFocus(true);
                              }
                            }}
                          >
                            <span>+</span>
                          </VisibilitySensor>
                        </div>
                      )}
                    </CountUp>
                  </span>
                </div>
                <div className={styles.count_text}>Students benefited</div>
              </li>
              <li>
                <div className={styles.count_number}>
                  <span>
                    <CountUp
                      start={focus ? 0 : null}
                      end={200}
                      duration={2}
                      redraw={true}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                          <VisibilitySensor
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setFocus(true);
                              }
                            }}
                          >
                            <>
                              <span>K</span>
                              <span>+</span>
                            </>
                          </VisibilitySensor>
                        </div>
                      )}
                    </CountUp>
                  </span>
                </div>
                <div className={styles.count_text}>Live training delivered</div>
              </li>
              <li>
                <div className={styles.count_number}>
                  <span>
                    <CountUp
                      start={focus ? 0 : null}
                      end={50}
                      duration={2}
                      redraw={true}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                          <VisibilitySensor
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setFocus(true);
                              }
                            }}
                          >
                            <span>+</span>
                          </VisibilitySensor>
                        </div>
                      )}
                    </CountUp>
                  </span>
                </div>
                <div className={styles.count_text}>Educators</div>
              </li>
              <li>
                <div className={styles.count_number}>
                  <span>
                    <CountUp
                      start={focus ? 0 : null}
                      end={1000}
                      duration={2}
                      redraw={true}
                    >
                      {({ countUpRef }) => (
                        <div>
                          <span ref={countUpRef} />
                          <VisibilitySensor
                            onChange={(isVisible) => {
                              if (isVisible) {
                                setFocus(true);
                              }
                            }}
                          >
                            <span>+</span>
                          </VisibilitySensor>
                        </div>
                      )}
                    </CountUp>
                  </span>
                </div>
                <div className={styles.count_text}>Free Videos/Ebooks</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElearningHomeCount;
